import { render, staticRenderFns } from "./exhibition_list.vue?vue&type=template&id=22e41743&scoped=true&"
import script from "./exhibition_list.vue?vue&type=script&lang=js&"
export * from "./exhibition_list.vue?vue&type=script&lang=js&"
import style0 from "./exhibition_list.vue?vue&type=style&index=0&id=22e41743&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e41743",
  null
  
)

export default component.exports